import React from 'react';

import { ListingPageRowActions } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';
import { ProcessedUserRow } from '@futrli/views/processors/users/usersList';

import { useUserActionItems } from '../../../../hooks/use-user-action-items/use-user-action-items';

interface UserRowActionsProps {
  user: ProcessedUserRow;
}

export const UserRowActions = ({ user }: UserRowActionsProps) => {
  const items = useUserActionItems({ user });

  return <ListingPageRowActions items={items} />;
};
